"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Spinner_styled_exports = {};
__export(Spinner_styled_exports, {
  StyledSpinner: () => StyledSpinner,
  StyledWrapper: () => StyledWrapper
});
module.exports = __toCommonJS(Spinner_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var StyledWrapper = import_styled_components.default.div.withConfig({
  displayName: "Spinnerstyled__StyledWrapper",
  componentId: "sc-lkh40m-0"
})(function(_ref) {
  var theme = _ref.theme, sizeValue = _ref.sizeValue;
  return (0, import_styled_components.css)(["background-color:", ";width:", ";height:", ";"], theme.colors.transparent, (0, import_mixins.withMultipleOf)("medium", sizeValue), (0, import_mixins.withMultipleOf)("medium", sizeValue));
});
var StyledSpinner = import_styled_components.default.div.withConfig({
  displayName: "Spinnerstyled__StyledSpinner",
  componentId: "sc-lkh40m-1"
})(function(_ref2) {
  var theme = _ref2.theme, speedValue = _ref2.speedValue;
  var _theme$colors = theme.colors, black = _theme$colors.black, white = _theme$colors.white;
  return (0, import_styled_components.css)(["position:relative;z-index:0;width:100%;height:100%;overflow:hidden;background-color:", ";&:before{content:'';position:absolute;z-index:-2;left:-50%;top:-50%;width:200%;height:200%;background-repeat:no-repeat;background-size:50% 50%,50% 50%;background-position:0 0,100% 0,100% 100%,0 100%;background-image:linear-gradient(", ",", "),linear-gradient(", ",", "),linear-gradient(", ",", "),linear-gradient(", ",", ");animation:rotate ", "s linear infinite;}&:after{content:'';position:absolute;z-index:-1;left:4px;top:4px;width:calc(100% - 8px);height:calc(100% - 8px);background:", ";}@keyframes rotate{100%{transform:rotate(1turn);}}"], theme.colors.primary.base, black, black, black, black, black, black, white, white, speedValue, white);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledSpinner,
  StyledWrapper
});
//# sourceMappingURL=Spinner.styled.js.map